import React, { useState, useEffect } from"react";

import { Badge, Modal, Spinner } from"react-bootstrap";
import { WindowHeader, WindowFooter } from"layouts/Page/windows";

import { CurrentLoginDTO, RelationData, ProfileData } from"../ProfileDropdown";
export type { CurrentLoginDTO, RelationData, ProfileData };

import type { UserAcesse } from"api/generated/model";

import List from"./components/List";

export type UserAcesseItem = UserAcesse;

const AcessesWindows: React.FC<{
    onHide: () => void;
    relationData: RelationData;
}> = ({ onHide, relationData }) => {
    return (
        <Modal show={true} onHide={onHide} size="lg" centered>
            <WindowHeader title="Trocar de conta" />
            <Modal.Body className="p-3">
                <List relationData={relationData} onHide={onHide} />
                <WindowFooter onCancel={onHide} cancelLabel="Fechar" hideConfirm />
            </Modal.Body>
        </Modal>
    );
};

export default AcessesWindows;


